// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter as Router } from "react-router-dom";
// import { AppContext } from "./Context/AppContext";

// import 'primereact/resources/themes/saga-blue/theme.css';
// import 'primereact/resources/primereact.min.css';
// import 'primeicons/primeicons.css';
// import 'primeflex/primeflex.css';


// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <AppContext>
//     <Router>
//       <App />
//     </Router>
//   </AppContext>
// );


import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { AppProvider } from "./Context/AppContext";
import { AuthProvider } from "./Context/AuthContext";
import { NotificationProvider } from "./Context/NotificationContext";

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { OrderProvider } from "./Context/OrderContext";
import './styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    {/* NotificationProvider wraps the app to provide FCM and notification state */}
   
      <AppProvider>
        <OrderProvider>
        <NotificationProvider>
          <Router>
            <App />
          </Router>
          </NotificationProvider>
        </OrderProvider>
      </AppProvider>
    
  </AuthProvider>
);
